'use strict'
const cssUtils = require('./cssUtils')
const _ = require('lodash')

const GOOGLE_FONT_SERVICE_URL = '//fonts.googleapis.com/css?family='


const createFontUtils = fontsMetadata => {
    const { parseFontStr, fromTextThemeToFontStyle } = cssUtils

    function getDropDownValues() {
        const validFonts = Object.keys(fontsMetadata).filter(key =>
            (getFontsUrlWithParams({[key]:fontsMetadata[key]}, "WixSite")).length > 0
        );
        const fontsArray = validFonts.map(key => ({
            label: fontsMetadata[key].displayName,
            value: fontsMetadata[key].fontFamily
        }));

        return fontsArray;
    }

    function getFontsUrlWithParams(fontNamesObject, documentType, characterSets) {
        const fontsFamiliesArray = _.isArray(fontNamesObject) ? fontNamesObject : _.keys(fontNamesObject)
        const query = getFontsQuery(fontsFamiliesArray, documentType, characterSets)
        if (query) {
            return GOOGLE_FONT_SERVICE_URL + query
        }

        return ''
    }

    function getFontsQuery(fontsFamiliesArray, documentType, characterSets) {
        let fontQuery = ''
        const permissions = getFontsPermissions(documentType)
        _.forEach(fontsFamiliesArray, function (fontFamily) {
            const font = fontsMetadata[fontFamily]
            if (font && font.cdnName && _.includes(permissions, font.permissions)) {
                fontQuery += `${font.cdnName}:n,b,i,bi|`
            }
        })
        if (fontQuery === '') {
            return null
        }
        if (characterSets) {
            fontQuery += `&subset=${characterSets.join(',')}`
        }
        return fontQuery
    }

    function getFontsPermissions(documentType) {
        const permissions = ['all', 'legacy']
        if (documentType === 'WixSite') {
            permissions.push('studio')
        }
        return permissions
    }

    return {
        parseFontStr,
        getFontsUrlWithParams,
        getDropDownValues
    }
}

module.exports = createFontUtils